module.exports = __webpack_public_path__ + "static/grafika6-aa1975568db4406c3aa614262d73e835.png";